import FabrickIcon from 'images/icons/components/icn-type-fabrick.svg';
import SplindleIcon from 'images/icons/components/icn-type-spindle.svg';
import LiningIcon from 'images/icons/components/icn-type-lining.svg';
import DownPackIcon from 'images/icons/components/icn-type-down-pack.svg';
import FurIcon from 'images/icons/components/icn-type-fur.svg';
import RibIcon from 'images/icons/components/icn-type-rib.svg';
import InterliningIcon from 'images/icons/components/icn-type-interlining.svg';
import InnerCottonIcon from 'images/icons/components/icn-type-inner-cotton.svg';
import WappenIcon from 'images/icons/components/icn-type-wappen.svg';
import ButtonIcon from 'images/icons/components/icn-type-button.svg';
import EyeletIcon from 'images/icons/components/icn-type-eyelet.svg';
import ElasticIcon from 'images/icons/components/icn-type-elastic.svg';
import DotButtonIcon from 'images/icons/components/icn-type-dot-button.svg';
import ZipperIcon from 'images/icons/components/icn-type-zipper.svg';
import KindOfDownIcon from 'images/icons/components/icn-type-kind-of-down.svg';
import StopperIcon from 'images/icons/components/icn-type-stopper.svg';
import EmptyComponentIcon from 'images/icons/icn-empty-component.svg';
import TapeCordIcon from 'images/icons/components/icn-type-tape-cord.svg';
import MaruElasticIcon from 'images/icons/components/icn-type-maru-elastic.svg';
import OtherFindingsIcon from 'images/icons/components/icn-type-other-findings.svg';

export default function icons() {
  return {
    'fabric-icon': FabrickIcon,
    'button-icon': ButtonIcon,
    'tape-cord-icon': TapeCordIcon,
    'stopper-icon': StopperIcon,
    'dot-button-icon': DotButtonIcon,
    'kind-of-down-icon': KindOfDownIcon,
    'down-pack-icon': DownPackIcon,
    'maru-elastic-icon': MaruElasticIcon,
    'elastic-icon': ElasticIcon,
    'wappern-icon': WappenIcon,
    'eyelet-icon': EyeletIcon,
    'fur-icon': FurIcon,
    'inner-cotton-icon': InnerCottonIcon,
    'interlining-icon': InterliningIcon,
    'lining-icon': LiningIcon,
    'findings-icon': OtherFindingsIcon,
    'rib-icon': RibIcon,
    'spindle-icon': SplindleIcon,
    'zipper-icon': ZipperIcon,
    'empty': EmptyComponentIcon,
  };
}

export function getProductCategoryName(i18n, typeLabelPL, typeLabelEN) {
  return i18n.language === 'en' ? typeLabelEN : typeLabelPL;
}
